import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { bool, func, shape } from "prop-types";
import { routerActions } from "connected-react-router";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as formActions, selectors as formSelectors } from "reducers/form";
import { useLocation, useParams } from "react-router-dom";
import Button from "pages/_components/Button";

import Notification from "pages/_components/Notification";
import MainContainer from "pages/_components/MainContainer";

import { ResponsiveHeader } from "pages/_components/header";

import { Col, Row } from "react-bootstrap";
import CustomButton from "pages/_components/CustomButton/CustomButton";

import {
    TransactionCard,
    TransactionHeader,
    TransactionInfo,
    TransactionSign,
} from "pages/_components/TransactionCard";
import CustomData from "pages/_components/CustomData/CustomData";
import { isEmpty } from "lodash";

const PendingTransactionPage = ({
    dispatch,
    fetching,
    transaction,
    newAccountTicketSignable,
    isDesktop,
    newAccountTicket,
}) => {
    const { id } = useParams();
    const { pathname, state = {} } = useLocation();
    const isLoading = fetching || !transaction?.data;
    const [showMoreData, setShowMoreData] = useState(false);
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const isBackoffice = pathname.includes("backoffice");
    const backofficePending = transaction?.data?.backofficePending;
    const backLinkTo = newAccountTicket?.backLinkTo || null;
    const subtitle = {
        PENDING: backofficePending ? "pending.approval" : "accounts.create.transactionRequest.firstTitle",
        CANCELLED: null,
        FAILED: null,
    };

    useEffect(() => {
        if (id && isEmpty(state?.transaction)) {
            dispatch(formActions.readTransactionTicket(id));
        }
    }, [id, dispatch]);

    useEffect(
        () => () => {
            dispatch(accountsActions.cleanNewAccountTicket());
        },
        [],
    );

    const handleSignTransaction = () => {
        dispatch(
            accountsActions.setNewAccountData({
                account: { productType: transaction?.data?.account?.productType },
                periodicity: transaction?.data?.periodicity || "",
                purpose: transaction?.data?.purpose || "",
                purposeReason: transaction?.data?.purposeReason || "",
                modalities: transaction?.data?.modalities || [],
                modalityReason: transaction?.data?.modalityReason || "",
                messageToBank: transaction?.data?.messageToBank,
                idTransaction: transaction?.idTransaction,
            }),
        );
        dispatch(routerActions.push("/accounts/summaryForm"));
    };
    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    return (
        <Fragment>
            <Notification scopeToShow="accounts" />
            {!isBackoffice && (
                <ResponsiveHeader
                    ticket
                    id="accounts.create.transactionRequest.secondTitle"
                    metaTitle="accounts.create.title"
                    backLinkTo={backLinkTo}
                />
            )}
            <MainContainer showLoader={isLoading}>
                <div className="container transaction-ticket">
                    <TransactionCard transaction={transaction}>
                        <TransactionHeader
                            title="accounts.create.transactionRequest.secondTitle"
                            subTitle={subtitle[transaction?.idTransactionStatus]}
                        />
                        <div className="ticket account-pending">
                            <div className="ticket__wrapper">
                                <div className="ticket__header" />

                                <div className="ticket__body">
                                    <div className="ticket-header-info">
                                        <TransactionInfo
                                            className="accountType"
                                            field="accounts.create.accountType"
                                            i18nId={`accounts.create.accountType.${transaction?.data?.account?.productType}`}
                                        />
                                    </div>
                                    <div className="view-more-data-button">
                                        <div className="ticket__divider inside-ticket__body">
                                            <div className="ticket__notch ticket__notch--left"> </div>
                                            <div className="ticket__notch ticket__notch--right"> </div>
                                        </div>
                                        <Button
                                            aria-expanded={showMoreData ? "true" : "false"}
                                            className="more-button"
                                            label={buttonLabel}
                                            bsStyle="link"
                                            onClick={handleSeeMoreData}
                                            image={
                                                showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"
                                            }
                                        />
                                    </div>
                                    <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                                        <h2>{i18n.get("", "Datos de la solicitud")}</h2>

                                        <CustomData
                                            dataClass="modalities"
                                            titleText="accounts.create.modalities"
                                            titleTextType="I18N"
                                            valueText={
                                                <>
                                                    {transaction?.data?.modalities.map((modality, index) => (
                                                        <span className="data-desc" key={modality}>
                                                            {!!index && ", "}
                                                            {i18n.get(`accounts.create.modality.${modality}`)}
                                                        </span>
                                                    ))}
                                                    {!!transaction?.data?.modalityReason.length && (
                                                        <span className="data-desc">
                                                            {!!transaction?.data?.modalities.length && ", "}
                                                            {transaction?.data?.modalityReason}
                                                        </span>
                                                    )}
                                                </>
                                            }
                                            valueTextType="TEXT"
                                        />
                                        <TransactionInfo
                                            className="periodicity"
                                            field="accounts.create.periodicity"
                                            i18nId={`accounts.create.periodicity.${transaction?.data?.periodicity}`}
                                        />
                                        <TransactionInfo
                                            className="messageToBank"
                                            field="accounts.create.messageToBank"
                                            value={transaction?.messageToBank}
                                        />
                                        <TransactionInfo className="purpuse2" field="accounts.create.purpose">
                                            {transaction?.data?.purpose === "OTHER"
                                                ? transaction?.data?.purposeReason
                                                : i18n.get(`accounts.create.purpose.${transaction?.data?.purpose}`)}
                                        </TransactionInfo>
                                        <TransactionInfo
                                            className="messageToBank2"
                                            field="accounts.create.messageToBank"
                                            value={transaction?.data?.messageToBank}
                                        />
                                        <TransactionSign
                                            showMoreData={showMoreData}
                                            showSignaturesInPending
                                            isDesktop={isDesktop}
                                            customText="pending.approval.cybo"
                                            creationTime
                                            isSmall
                                            noDate={!backofficePending}
                                        />
                                    </div>
                                </div>
                                <div className="ticket__footer" data-copytext={i18n.get("global.ticketCopyText")} />
                            </div>
                        </div>
                    </TransactionCard>

                    {!isBackoffice && (
                        <Row className="form-actions">
                            {newAccountTicketSignable && !transaction?.data?.backofficePending ? (
                                <>
                                    <Col xs={12} md={4} mdOffset={2}>
                                        <CustomButton
                                            func={() => dispatch(routerActions.push("/desktop"))}
                                            text="forms.transaction.ticket.actions.backToHome"
                                            textType="I18N"
                                            className="btn btn-outline"
                                        />
                                    </Col>
                                    <Col xs={12} md={4}>
                                        <CustomButton
                                            func={handleSignTransaction}
                                            text="forms.signTransaction.link"
                                            textType="I18N"
                                            className="btn btn-primary"
                                        />
                                    </Col>
                                </>
                            ) : (
                                <Col xs={12} md={4} mdOffset={4}>
                                    <CustomButton
                                        func={() => dispatch(routerActions.push("/desktop"))}
                                        text="forms.transaction.ticket.actions.backToHome"
                                        textType="I18N"
                                        className="btn btn-primary"
                                    />
                                </Col>
                            )}
                        </Row>
                    )}
                </div>
            </MainContainer>
        </Fragment>
    );
};

PendingTransactionPage.propTypes = {
    newAccountTicketSignable: bool.isRequired,
    transaction: shape({}).isRequired,
    dispatch: func.isRequired,
    fetching: bool,
    isDesktop: bool,
};

PendingTransactionPage.defaultProps = {
    fetching: false,
    isDesktop: false,
};

const mapStateToProps = (state) => ({
    newAccountTicketSignable: accountsSelectors.getNewAccountTicketSignable(state),
    transaction: formSelectors.getTransaction(state),
    fetching: accountsSelectors.getFetching(state),
    newAccountTicket: accountsSelectors.getNewAccountTicket(state),
});

export default connect(mapStateToProps)(PendingTransactionPage);
